import PropTypes from 'prop-types';
import { Box, Divider, IconButton, Typography } from '@mui/material';
// project import
import { styled, useTheme } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

const drawerWidth = 240;

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
    minHeight: '66px',
}));

const DrawerRight = ({ open = false, onDrawer = () => {}, children }) => {
    const theme = useTheme();

    const handleDrawer = () => {
        onDrawer(!open);
    };

    return (
        <>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                    },
                }}
                variant="persistent"
                anchor="right"
                open={open}
            >
                <DrawerHeader>
                    <IconButton onClick={handleDrawer}>
                        {theme.direction === 'rtl' ? (
                            <KeyboardDoubleArrowLeftIcon />
                        ) : (
                            <KeyboardDoubleArrowRightIcon />
                        )}
                    </IconButton>
                    <Typography
                        variant="h6"
                        noWrap
                        sx={{ marginLeft: '12px', flexGrow: 1 }}
                        component="div"
                    >
                        Actions
                    </Typography>
                </DrawerHeader>
                <Divider />
                <Box sx={{ padding: '24px 8px' }}> {children}</Box>
            </Drawer>
        </>
    );
};

DrawerRight.propTypes = {
    open: PropTypes.bool,
    onDrawer: PropTypes.func,
    children: PropTypes.node,
};

export default DrawerRight;
